module.exports = __webpack_public_path__ + "static/fonts/Fact-Black.311d936.eot";